import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import ucfirst from '@/helpers/ucfirst';

const defaultProps = {
  className: null,
};

const propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const Icon = ({ name, className }) => {
  if (name === '') {
    return null;
  }

  const iconName = name
    .toString()
    .split('-')
    .map((p) => ucfirst(p))
    .join('');
  const IconComponent = dynamic(() => import(`./${iconName}`));

  return <IconComponent className={className} />;
};

Icon.defaultProps = defaultProps;
Icon.propTypes = propTypes;

export default Icon;
